import axios, { AxiosInstance } from "axios";
import { retrieveFromLocal } from "../helper/localStore";

const getToken = () => {
  try {
    return retrieveFromLocal("token");
  } catch {
    return null;
  }
};

const createApiService = (baseURL?: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = getToken();

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
};

const apiService = createApiService(process.env.REACT_APP_BACKEND_URL);
const apiServiceV2 = createApiService(process.env.REACT_APP_BACKEND_URL_V2);

export { apiService, apiServiceV2 };
